module.exports = __webpack_public_path__ + "static/css-ruleset-87b8e1597ac88351ac3be3223080c769.svg";